import { render } from "./LlmPricesPanel.vue?vue&type=template&id=52f27de0&scoped=true"
import script from "./LlmPricesPanel.vue?vue&type=script&lang=js"
export * from "./LlmPricesPanel.vue?vue&type=script&lang=js"

import "./LlmPricesPanel.vue?vue&type=style&index=0&id=52f27de0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f27de0"]])

export default __exports__